import { Order, OutgoingItemGroup, IncomingItemGroup } from '../../../../model/order';
import { DeliveryStatus } from '../../../../model/delivery';
import { InvoiceStatus } from '../../../../model/invoice';
import { VenueSection, VenueSeat } from '../../../../model/venue';
import { Event } from '../../../../model/event';
import { ActivityItem } from '../../../../model/activity';

export function getItemStatus(
  order: Order,
  row: OutgoingItemGroup | IncomingItemGroup
): DeliveryStatus | InvoiceStatus {
  const invoice = order.invoices.find((invoice) => invoice.id === row.invoiceId);
  const delivery = order.deliveries.find((delivery) => delivery.id === row.deliveryId);

  const progressionTable = {
    draft: 0,
    pending: 1,
    fulfillment: 2,
    booked: 2,
    sent: 3,
    canceled: 3,
  };

  const status = [delivery?.status, row.__typename === 'IncomingItemGroup' && delivery?.status, invoice?.status]
    .filter(Boolean)
    .sort((a, b) => progressionTable[a as string] - progressionTable[b as string]); // then we can confidently cast to string

  return status[0] || 'draft';
}

export type groupedActivityItem = ActivityItem & {
  itemIds: string[];
  seatIds: string[];
};

export function getSeatFromEvent(event: Event, seatId: string): VenueSeat | undefined {
  return event?.venuePlan?.sections
    .map((venueSection: VenueSection) => {
      const foundSeat = venueSection.seats.find((seat) => seat.id === seatId);
      if (foundSeat) {
        return { ...foundSeat, sectionName: venueSection.name };
      }
      return;
    })
    .filter(Boolean)[0];
}
